<template>
    <div class="max-w-fit px-4 py-3 border-2 border-orange-500 rounded hover:cursor-pointer uppercase">{{ content }}</div>
</template>

<script setup>
defineProps(['content'])
</script>